<template>
  <AppDialog
    :open="visible"
    @close="handleLogin"
    :title="error ? 'Abgelaufener Link' : 'Newsletter abonniert'"
  >
    <div v-if="error">
      <ul class="formulate-form-errors">
        <li role="alert" aria-live="assertive" class="formulate-form-error">
          {{ error }}
        </li>
      </ul>
      <t-button classes="span-full" :action="handleRegister"
        >Zur Registrierung</t-button
      >
    </div>
    <div v-else>
      <p>Vielen Dank für Ihre Anmeldung für den Newsletter von Factfield.</p>
      <t-button classes="span-full" :action="handleLogin"
        >Zur Startseite</t-button
      >
    </div>
  </AppDialog>
</template>

<script>
import AppDialog from "@/components/Dialog/AppDialog";
import TButton from "@/components/Layout/Button";
import UserService from "@/services/user";
import { errorHandler } from "@/router/utils";

export default {
  name: "AccountActivatedDialog",
  components: { TButton, AppDialog },
  data() {
    return {
      error: null,
      visible: false,
    };
  },

  mounted() {
    this.activate();
  },

  methods: {
    handleRegister() {
      this.visible = false;
      this.$nextTick(() => this.$router.push("/register").catch(errorHandler));
    },
    handleLogin() {
      this.visible = false;
      this.$nextTick(() => this.$router.push("/").catch(errorHandler));
    },
    async activate() {
      try {
        this.error = null;
        await UserService.confirmNewsletter({
          token: this.$route.params.token,
        });
      } catch (e) {
        if (e.response && e.response.status === 410) {
          this.error = "Dieser Link ist nicht mehr gültig!";
        } else {
          this.error = e.message;
        }
        console.error(e);
      }
      this.visible = true;
    },
  },
};
</script>

<style scoped lang="postcss">
p {
  @apply mb-8;
}
</style>
